import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const expensesApi = {
  // CREATE
  create: async (data) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/expenses`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  createType: async (data) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/expenses/type`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  // GET
  get: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/expenses/byDates`, { params });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default expensesApi;
